import React from 'react'
import scrollTo from "../utils/scrollToTop";

const ScrollToTop = props => (
    <div style={styles.scrollToTopContainer} className="scrollToTop" onClick={_ => { scrollTo(0); }}>
        <i className="fas fa-angle-up" style={styles.scrollToTopIcon}></i>
    </div>
);

const styles = {
    scrollToTopContainer: {
        width: 40,
        height: 40,
        padding: 10,
        backgroundColor: "#C80A48",
        position: "fixed",
        zIndex: 99,
        right: 24,
        cursor: "pointer",
        bottom: 24,
        color: "#fff",
        borderRadius: 40,
        transition: "all 0.40s ease",
        textAlign: "center",
        display: "none"
    },
    scrollToTopIcon: {
        fontSize: 20,
    }
};

export default ScrollToTop;


// WEBPACK FOOTER //
// ./src/Components/scrollToTop.jsx